import React from 'react'

import Events from './Events'
import Tasks from './Tasks'

import styles from './styles.module.scss'
import AiInfos from './Infos'

interface TaskData {
  task_status?: string
  [key: string]: any
}

interface AiExtractionData {
  tasks?: TaskData[]
  events?: any[]
  infos?: any[]
}

interface AiExtractionProps {
  mailId: string
  aiExtraction: AiExtractionData
}

const AiExtraction: React.FC<AiExtractionProps> = ({ mailId, aiExtraction }) => {
  const { tasks, events, infos } = aiExtraction

  const validTasks = tasks?.filter((task) => task.task_status !== 'ignore') as any

  return (
    <div className={styles.aiExtraction}>
      <Events events={events} mailId={mailId} />
      <div className={styles.divider} />
      <Tasks tasks={validTasks} mailId={mailId} />
      <div className={styles.divider} />
      <AiInfos infos={infos} />
      <div className={styles.divider} />
    </div>
  )
}

export default AiExtraction
